import './scripts/common';
import {find} from '@elements/dom-utils';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};
import {onFind} from "@elements/init-modules-in-scope";

import Tooltip from 'bootstrap/js/dist/tooltip';
onFind('[data-bs-toggle="tooltip"]', (element) => {
    new Tooltip(element);
});

import * as numberSpinner from '@elements/number-spinner';
numberSpinner.init();

import * as datepicker from "@elements/datepicker";
datepicker.init();

import * as filter from "./scripts/filter.js";
filter.init();

import * as triggerSubmit from './scripts/trigger-submit';
triggerSubmit.init();

import * as ticketCheckbox from './scripts/ticket-checkbox';
ticketCheckbox.init();

import * as datepickerRadioFilter from './scripts/datepicker-radio-filter';
datepickerRadioFilter.init();

import * as ajaxForm from '@elements/ajax-form';
ajaxForm.init();

import * as ajaxFormExtend from './scripts/ajax-form-extend';
ajaxFormExtend.init();

import * as imageSlider from './scripts/image-slider';
imageSlider.init();

import * as eventCardTeaserSlider from './scripts/event-card-teaser-slider';
eventCardTeaserSlider.init();

import * as eventImgTeaserSlider from './scripts/event-img-teaser-slider';
eventImgTeaserSlider.init();

import * as affix from './scripts/elements-packages/affix';
affix.createAffix(find('.js-affix-sidebox'), {mediaQuery: '(min-width: 768px)'}, {
    base: '.js-affix-sidebox',
    placeholder: '.js-affix-sidebox__placeholder',
    container: '.js-affix-sidebox__container'
});


import * as fadeIn from "./scripts/fade-in";
fadeIn.init();



import * as parallax from "./scripts/parallax";
parallax.init();

import * as dynamicLightbox from './scripts/dynamic-lightbox';
dynamicLightbox.init();

import * as lightbox from '@elements/lightbox';
lightbox.init({
        plugins: ['zoom', 'video'],
        zoom: true,
        video: true
    }
);

import * as productGrid from '@elements/product-grid';
productGrid.init();